export default __webpack_public_path__ + "static/media/MedicoSeguro.238e5ed6.svg";